import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { AUTH_APPLY_CHECK, AUTH_SET, NOTIFY_DELETE, NOTIFY_GETNUM, NOTIFY_LIST, TRANSOWNER_ACCEPT, TRANSOWNER_REJECT, } from './cgi-path';
import { networkRequest } from '@tencent/ark-request';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { addURLParameters } from '@tencent/ark-utils/lib/url';
var NotificationRepository = /** @class */ (function () {
    // networkRequest 注入
    function NotificationRepository(networkRequestService) {
        this.networkRequestService = networkRequestService;
    }
    // 获取通知中心未读数
    NotificationRepository.prototype.notifyGetNum = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                params = {
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                };
                url = addURLParameters(NOTIFY_GETNUM, params);
                return [2 /*return*/, networkRequest.get(url)];
            });
        });
    };
    // 拉取通知中心记录列表
    NotificationRepository.prototype.notifyList = function (start) {
        return __awaiter(this, void 0, void 0, function () {
            var url_1, url;
            return __generator(this, function (_a) {
                if (start) {
                    url_1 = addURLParameters(NOTIFY_LIST, { xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)), start: start });
                    return [2 /*return*/, networkRequest.get(url_1)];
                }
                url = addURLParameters(NOTIFY_LIST, { xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)) });
                return [2 /*return*/, networkRequest.get(url)];
            });
        });
    };
    // 拉取当前文档的通知中心审批记录列表
    NotificationRepository.prototype.currentDocNotifyList = function (domainId, localPadId, start) {
        return __awaiter(this, void 0, void 0, function () {
            var url, params, params;
            return __generator(this, function (_a) {
                if (start) {
                    params = {
                        xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                        domainId: domainId,
                        localPadId: localPadId,
                        start: start,
                    };
                    url = addURLParameters(NOTIFY_LIST, params);
                }
                else {
                    params = {
                        xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                        domainId: domainId,
                        localPadId: localPadId,
                    };
                    url = addURLParameters(NOTIFY_LIST, params);
                }
                return [2 /*return*/, networkRequest.get(url)];
            });
        });
    };
    // 权限申请审批
    NotificationRepository.prototype.authSet = function (domainId, localPadId, notifyId, setInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                params = {
                    xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                    domainId: domainId,
                    localPadId: localPadId,
                    notifyId: notifyId,
                    setInfo: setInfo,
                };
                url = "".concat(AUTH_SET);
                return [2 /*return*/, networkRequest.post(url, params)];
            });
        });
    };
    // check审批状态
    NotificationRepository.prototype.authApplyCheck = function (domainId, localPadId) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                params = {
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                    domainId: domainId,
                    localPadId: localPadId,
                };
                url = addURLParameters(AUTH_APPLY_CHECK, params);
                return [2 /*return*/, networkRequest.get(url)];
            });
        });
    };
    // 删除审批
    NotificationRepository.prototype.notifyDelete = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                params = {
                    id: id,
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                };
                url = addURLParameters(NOTIFY_DELETE, params);
                return [2 /*return*/, networkRequest.get(url)];
            });
        });
    };
    // 同意文档转让
    NotificationRepository.prototype.transownerAccept = function (domainId, localPadId, notifyId, setInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                params = {
                    xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                    domainId: domainId,
                    localPadId: localPadId,
                    notifyId: notifyId,
                    setInfo: setInfo,
                };
                url = "".concat(TRANSOWNER_ACCEPT);
                return [2 /*return*/, networkRequest.post(url, params)];
            });
        });
    };
    // 拒绝文档转让
    NotificationRepository.prototype.transownerReject = function (domainId, localPadId, notifyId, setInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                params = {
                    xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                    domainId: domainId,
                    localPadId: localPadId,
                    notifyId: notifyId,
                    setInfo: setInfo,
                };
                url = "".concat(TRANSOWNER_REJECT);
                return [2 /*return*/, networkRequest.post(url, params)];
            });
        });
    };
    NotificationRepository = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object])
    ], NotificationRepository);
    return NotificationRepository;
}());
export { NotificationRepository };
